/**
 * Returns the effective top-level domain (public suffix) with preceding dot
 * for the current location hostname, e.g. '.com', '.co.uk', '.org', '.com.au'.
 *
 * Notes:
 * - Works for simple TLDs (example.com) and multi-part TLDs (example.co.uk)
 * - Falls back to empty string when hostname is unavailable or cannot be parsed
 */
function getTopLevelDomain(): string {
  if (typeof window === 'undefined') return '';

  const hostname = window.location?.hostname || '';
  if (!hostname || hostname === 'localhost') return '';

  const parts = hostname.split('.').filter(Boolean);
  if (parts.length < 2) return '';

  const last = parts[parts.length - 1] as string;
  const secondLast = parts[parts.length - 2] as string;
  // Heuristic:
  // - If the final label is a 2-letter ccTLD, treat the suffix as two parts
  //   e.g. example.co.uk -> .co.uk, example.com.au -> .com.au
  // - Otherwise, use the single final label (e.g. .com, .org)
  if (last.length === 2 && parts.length >= 2) {
    return `.${secondLast}.${last}`;
  }

  return `.${last}`;
}

export { getTopLevelDomain };
